import React from "react";
import { isAuthenticated } from "../utils/authHelper";
import { Navigate, Link } from "react-router-dom";
import '../styles/landing.css';
import LandingNavBar from "../components/LandingNavBAr";
import Landing_pc from "../components/Landing_pc";
import Landing_mobile from "../components/Landing_mobile";


function Landing() {
    if (isAuthenticated()) { return <Navigate to="/profile" />; }

    return (
        <div >

            <LandingNavBar />

            <div className="lpc"><Landing_pc /></div>

            <div className="lphone"><Landing_mobile /></div>

        </div>
    );


} export default Landing;



// <div className="p-0 m-0">
{/* <LandingNavBar />

<div className="container-fluid p-0">

    <div className="row g-0 full-height bg-section-1">

        <div className="col-md-6 d-flex align-items-center justify-content-center">
            <div className="text-center">
                <h1 className="slogan">Find Partners.<br />Find Brands.<br />Find Success.</h1>
                <p className="small-slogan" >Maximize your discoverability with a single profile, <br /> where brands, e-tailers, and content creators can effortlessly <br /> find and connect with each other.</p>
            </div>
        </div>

        <div className="col-md-6 d-flex align-items-center justify-content-center">
            <div className="text-center">
                <div className="col-md-3 mb-2 mb-md-0 icon">
                    <img src={`${apiEndpoint}/media/photos/l1.png`} alt="" className='infoimg' />
                </div>
            </div>
        </div>

    </div>

    <div className="row g-0 full-height bg-section-2">
        <div className="col-md-4 d-flex align-items-center justify-content-center order-2 order-md-1">
            <div className="text-center">
                <div className="col-md-3 mb-2 mb-md-0 icon">
                    <img src={`${apiEndpoint}/media/photos/l2.png`} alt="" className='infoimg2' />
                </div>
            </div>
        </div>

        <div className="col-md-8 d-flex align-items-center justify-content-center order-1 order-md-2">
            <div className="text-center">
                <h1 className="slogan">
                    Create your
                    <br />
                    Partnerli profile
                    <br />
                    in minutes
                </h1>
                <p className="small-slogan">
                    Verify your social media accounts,
                    <br />
                    add any links you want, introduce yourself.
                </p>
            </div>
        </div>
    </div>

    <div className="row g-0 full-height bg-section-3">
        <div className="col-md-6 d-flex align-items-center justify-content-center">
            <div className="text-center">
                <h1 className="slogan">Share your link</h1>
                <p className="small-slogan">Share the profile link you created on your social <br /> media accounts and allow potential partners and brands to reach you..</p>
            </div>
        </div>

        <div className="col-md-6 d-flex align-items-center justify-content-center">
            <div className="text-center">
                <div className="col-md-3 mb-2 mb-md-0 icon">
                    <img src={`${apiEndpoint}/media/photos/l3.png`} alt="" className='infoimg3' />
                </div>
            </div>
        </div>
    </div>

    <div className="row g-0 full-height bg-section-4">
        <div className="col-md-6 d-flex align-items-center order-2 justify-content-center order-md-1">
            <div className="text-center">
                <div className="col-md-3 mb-2 mb-md-0 icon">
                    <img src={`${apiEndpoint}/media/photos/l4.png`} alt="" className='infoimg4' />
                </div>

            </div>
        </div>

        <div className="col-md-6 d-flex align-items-center order-1 justify-content-center order-md-2">
            <div className="text-center">
                <h1 className="slogan">Contact</h1>
                <p className="small-slogan">Find and contact the most suitable partners and brands <br /> for you with advanced search methods</p>
            </div>
        </div>
    </div>

    <div className="row g-0 full-height bg-section-5">
        <div className=" allinone col-md-12 d-flex align-items-center  justify-content-center">
            <div className="text-center">
                <h1 className="slogan" style={{ textAlign: "center" }}>Find easily, be findable</h1>
                <Link to="/login"><button type="button" className="navbtn btn btn-outline-primary me-2">Get Started</button></Link>

                <div style={{ height: "10px" }} className="d-flex flex-column flex-sm-row justify-content-between pt-1 mt-5 ">

                    <a href="https://partnerli.com/termsofuse" target="_blank" rel="noopener noreferrer"><p className="m-0 pt-1 text-muted">terms of use</p></a>
                    <a href="https://partnerli.com/privacypolicy" target="_blank" rel="noopener noreferrer"><p className="m-0 pt-1 text-muted">privacy policy</p></a>
                    <p className=" pt-1 text-muted" style={{ marginBottom: "4px" }}>&copy; 2024 GULDAG · All rights reserved.</p>

                    <ul className="justify-content-center list-unstyled d-flex m-0">
                        <li style={{ paddingLeft: "5px", paddingRight: "5px" }} >
                            <a className="link-body-emphasis " href="https://x.com/home">
                                <svg style={{ marginBottom: "8px" }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" className="bi bi-instagram" viewBox="0 0 16 16">
                                    <path fill="#515857" d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334" />
                                </svg>
                            </a>
                        </li>
                        <li style={{ paddingLeft: "5px", paddingRight: "5px" }} >
                            <a className="link-body-emphasis" href="https://x.com/home">
                                <svg style={{ marginBottom: "8px" }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" className="bi bi-twitter-x" viewBox="0 0 16 16">
                                    <path fill="#515857" d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" />
                                </svg>
                            </a>
                        </li>

                        <li style={{ paddingLeft: "5px", paddingRight: "5px" }} >
                            <a className="link-body-emphasis" href="https://x.com/home">
                                <svg style={{ marginBottom: "8px" }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" className="bi bi-tiktok" viewBox="0 0 16 16">
                                    <path fill="#515857" d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3z" />
                                </svg>
                            </a>
                        </li>
                    </ul>


                </div>
            </div>
        </div>
    </div>

</div> */}
// </div>


{/* <div className="col-md-3 mb-2 mb-md-0 icon">
                                    <div
                                        style={{
                                            width: "420px",
                                            height: "420px",
                                            backgroundImage: `url(${apiEndpoint}/media/photos/l4.png)`,
                                            backgroundSize: "cover",
                                            viewBox: "0 0 16 16", // viewBox SVG için geçerlidir ve burada gereksizdir.
                                        }}
                                    ></div>
                                </div> */}